import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, deleteApi } from 'services/rotasp/api';
import { PATH_SGU_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, ExcluirFuncionalidadeRequest } from './types';

// ACTIONS
import {
	excluirFuncionalidadeSuccess,
	excluirFuncionalidadeFailure,
} from './actions';

function* excluirFuncionalidade(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: ExcluirFuncionalidadeRequest } = request;

	const response: ApiResponse = yield call(
		deleteApi,
		token || '',
		PATH_SGU_API,
		`funcionalidades/${payload.id}`,
	);

	if (response.status === 200) {
		yield put(excluirFuncionalidadeSuccess(response));
	} else {
		yield put(excluirFuncionalidadeFailure());
	}
}

export default all([
	takeLatest(Types.EXCLUIR_FUNCIONALIDADE, excluirFuncionalidade),
]);
